import { Col, Container, Row, Tab } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import CardGroup from "react-bootstrap/CardGroup";
import placeholderimage from "../assets/image/placeholder.png"
import githubicon from '../assets/image/nav-icon3.svg'
import taskManagerImage from "../assets/image/Task-manager.png"
import pythonProject from "../assets/image/people-form-map.png"
import OverlayTrigger from "react-bootstrap/OverlayTrigger"
import Tooltip from 'react-bootstrap/Tooltip'


export const Projects = () => {
    const renderTooltip = (props) => (
    <Tooltip id="link-tooltip" {...props}>
      Unfortunately I lost this project so I dont have the code for it.
    </Tooltip>
  );
  return (
    <section className="projects" id="projects">
      <Container>
        <Row>
          <Col>
            <h1>Projects</h1>
            
            <Tab.Container id="projects-tabs" defaultActiveKey="first">
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <CardGroup>
                    <Card className="project-cards" style={{ width: "18rem" }}>
                      <Card.Img className="card-img-projects" variant="top" src={taskManagerImage} />
                      <Card.Body>
                        <Card.Title>Task Manager</Card.Title>
                        <Card.Text>
                          <ul>

                            <li>
                              Designed and developed a full-stack task management application with Angular frontend and Spring Boot REST API backend.
                            </li>

                            <li>
                              Implemented full CRUD functionality with persistent storage using AWS RDS and Spring Data JPA.
                            </li>

                            <li>
                              Built a modular Angular architecture using standalone components and HttpClient services for API integration.
                            </li>

                            <li>
                              Designed RESTful endpoints and handled data validation, error handling, and entity updates.
                            </li>

                            <li>
                              Implemented task status workflow with synchronized frontend-backend state management.
                            </li>

                            <li>
                              Packaged the Angular application into a cross-platform desktop app using Electron.
                            </li>

                          </ul>
                        </Card.Text>
                      </Card.Body>
                        <Card.Footer>
                          <small className="github-link">
                            <a href="https://github.com/ryanajhnsn/TaskManager" target="_blank">Github Repository</a>
                            <img src={githubicon} alt="github" />  
                        </small>
                      </Card.Footer>
                    </Card>
                    
                    <Card className="project-cards" style={{ width: "18rem" }}>
                      <Card.Img className="card-img-projects" variant="top" src={pythonProject} />
                      <Card.Body>
                        <Card.Title>Form Applicant Data Organizer</Card.Title>
                        <Card.Text>
                          <ul>
                            <li>
                              Engineered a Python-based ETL workflow to process Google Form HTML submissions
                            </li>
                            <li>
                              Parsed and transformed unstructured HTML into relational data using BeautifulSoup4
                            </li>
                            <li>
                              Designed relational schema in MySQL with indexed fields for efficient querying
                            </li>

                            <li>
                              Integrated Google Maps API to geocode addresses and render dynamic map markers
                            </li>

                            <li>
                              Built interactive UI logic to fetch and display applicant data when markers were selected
                            </li>
                          </ul>




                        </Card.Text>
                      </Card.Body>
                      <Card.Footer>
                        <OverlayTrigger
                          placement="top"
                          delay={{ show:250, hide: 400 }}
                          overlay={renderTooltip}
                          >
                            <small className="disabled-link">
                            <a>Github Repository</a>
                            <img src={githubicon} alt="linkedin" />
                            </small>
                          </OverlayTrigger>
                      </Card.Footer>
                    </Card>

                    
{/* 
                    <Card className="project-cards" style={{ width: "18rem" }}>
                      <Card.Img className="card-img-projects" variant="top" src={placeholderimage} />
                      <Card.Body>
                        <Card.Title>Project 3</Card.Title>
                        <Card.Text>
                          This is a wider card with supporting text below as a natural lead-in to additional content.
                        </Card.Text>
                      </Card.Body>
                      <Card.Footer>
                        <small className="github-link">
                        <a href="https://www.linkedin.com/in/ryanajhnsn/" target="_blank">Github Repository</a>
                        <img src={githubicon} alt="linkedin" />  
                        </small>
                      </Card.Footer>
                    </Card> */}

                  </CardGroup>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
    </section>
  );
};